import { Facebook, Instagram, Twitter, Youtube, ShieldCheck } from "lucide-react";
import Crest from "@/components/Crest";
import { scrollToId } from "@/lib/scroll";

const NAV = [
  { id: "#timeline", label: "Timeline" },
  { id: "#schedule", label: "Schedule" },
  { id: "#houses", label: "Houses" },
  { id: "#map", label: "Campus Map" },
  { id: "#quiz", label: "Doon Lore" },
  { id: "#gallery", label: "Gallery" },
  { id: "#guestbook", label: "Guestbook" },
];

const SOCIALS = [
  { icon: Instagram, label: "Instagram", url: "https://www.instagram.com/thedoonschoolofficial/" },
  { icon: Facebook, label: "Facebook", url: "https://www.facebook.com/thedoonschoolofficial/" },
  { icon: Twitter, label: "Twitter", url: "https://twitter.com/The_Doon_School" },
  { icon: Youtube, label: "YouTube", url: "https://www.youtube.com/@thedoonschoolofficial/" },
];

export default function Footer({ onOpenAdmin }) {
  return (
    <footer className="relative border-t border-line/15 py-16" data-testid="footer">
      <div className="mx-auto max-w-7xl px-6">
        <div className="grid gap-12 md:grid-cols-[1.2fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-3">
              <Crest className="h-12 w-12" />
              <div>
                <p className="font-display text-base font-bold tracking-[0.2em] text-fg">THE DOON SCHOOL</p>
                <p className="font-mono text-[10px] tracking-[0.3em] text-gold">FOUNDER'S DAY • 91ST EDITION</p>
              </div>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-soft">
              An unofficial celebration experience marking ninety-one years of Legacy &amp; Leadership at Chandbagh, Dehradun — October 22–24, 2026.
            </p>
            <p className="mt-4 font-serif2 text-base italic text-gold">"Knowledge Our Light"</p>
          </div>

          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.35em] text-gold">Quick Navigation</p>
            <ul className="mt-5 grid grid-cols-2 gap-3">
              {NAV.map((n) => (
                <li key={n.id}>
                  <button onClick={() => scrollToId(n.id)} className="text-sm text-soft transition-colors hover:text-gold" data-testid={`footer-link-${n.label.toLowerCase()}`}>
                    {n.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.35em] text-gold">Follow the School</p>
            <div className="mt-5 flex gap-3">
              {SOCIALS.map((s) => (
                <a
                  key={s.label}
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`${s.label} (official school profile)`}
                  data-testid={`footer-social-${s.label.toLowerCase()}`}
                  className="glass flex h-11 w-11 items-center justify-center rounded-full text-soft transition-all duration-300 hover:-translate-y-1 hover:text-gold"
                >
                  <s.icon className="h-4 w-4" />
                </a>
              ))}
            </div>
            <a href="https://www.doonschool.com" target="_blank" rel="noopener noreferrer" className="mt-6 inline-block text-sm text-soft underline-offset-4 transition-colors hover:text-gold hover:underline" data-testid="footer-website-link">
              doonschool.com ↗
            </a>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-line/10 pt-8 sm:flex-row">
          <div className="text-center sm:text-left">
            <p className="text-xs text-soft">© 2026 • The Doon School Founder's Day Celebration • Made with pride for Chandbagh</p>
            <p className="mt-1.5 font-display text-[11px] font-bold tracking-[0.18em] text-gold" data-testid="footer-maker-credit">MADE BY JAVEN WILSON P KHARSYNTIEW — 535 MH/T</p>
            <p className="mt-0.5 text-[10px] text-soft/60">Campus photographs: Wikimedia Commons contributors (CC)</p>
          </div>
          <button onClick={onOpenAdmin} data-testid="footer-curator-button" className="flex items-center gap-2 text-xs text-soft transition-colors hover:text-gold">
            <ShieldCheck className="h-3.5 w-3.5" /> Wish Wall Curator
          </button>
          <p className="font-mono text-[10px] tracking-[0.3em] text-soft/70">EST. 1935 • DEHRADUN</p>
        </div>
      </div>
    </footer>
  );
}
